import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Rating } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    data?: any;
}

export default function ViewRating({ open, onClose, setOpen, data }: ModalProps) {
    if (!data) return null;

    return (
        <Modal className="modal addReply_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* Title Bar */}
                    <div className="modal_title">
                        <h2>Review</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Rating & Review Section */}
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Rating</h6>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Rating name="read-only" value={data.score || 0} precision={0.1} readOnly size="small" />
                            </div>
                        </div>

                        <div className="w_100">
                            <h6>Review</h6>
                            <p>{data.reviews || "No review text provided."}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
